import React, { Component } from 'react';
import Orders  from '../../containers/left-panel/orders';
import OrderSearch  from '../../containers/left-panel/order-search';
import GenerateReport  from '../../containers/left-panel/generate-report';
import Result  from '../../containers/right-panel/result';
import authentication from '../../services/authentication';
import getOrderResult from '../../services/getOrderResult';
import Login from '../login';
import * as translationUtils from '../../common-utils/translation_utils'
import { Redirect } from 'react-router';
/**
 * MainWrapper Class
 * This class is used as a main parent class for other sub-section classes.
 * 
 */
class MainWrapper extends Component {
  historyDta = {};
  constructor(props){
    console.log(props);
    
    super(props);
   
  if(props.location.state!=null){
    this.state = {
      filters : 'nein',
      newFilterFlag : false,
      authToken : props.location.state.authToken,
      authStatus : props.location.state.authStatus,
      intialOrderType : 'all',
      langCode : 'DE',
      result : [],
      pageNumber : 0,
      pageLength : window.initialPageLength
    };
  }else if (window.sessionStorage.getItem('token')!=null){
    this.state = {
      filters : 'nein',
      newFilterFlag : false,
      authToken : window.sessionStorage.getItem('token'),
      authStatus : true,
      intialOrderType : 'all',
      langCode : 'DE',
      result : [],
      pageNumber : 0,
      pageLength : window.initialPageLength
    };
  }

}


  componentDidMount(){
// console.log(this.props);
   // authentication(this);
    const { match: { params } } = this.props;
    translationUtils.setTranslations(this, params.langCode);
    if(params.type!==undefined){
      this.setState({
        intialOrderType : params.type,
        langCode : params.langCode
      });
    }
  }

  /**
   * Callback for Translations
   */
  translationCallback=(locale)=>{
    this.setState({
      langCode : locale
    });
  }
  
  /**
   * Callback for Auth Service
   * @param {string} auth_token 
   * @param {boolean} success 
   */
  setAuthToken=(auth_token, success)=>{
    this.setState({
      authToken: auth_token,
      authStatus: success
    });
  }

  resultCallBack=(data, pageNumber, pageLength)=>{
    this.setState({
      result: []
    });
    this.setState({
      result: data,
      pageNumber : pageNumber,
      pageLength : pageLength
    });
  }

  /**
   * Callback for Get Order Service
   * @param {JSON} data 
   * @param {boolean} authExpired 
   */
  setResultdata(data, authExpired=false, moreResults, total){
    if(!authExpired){
      window.loader(false);
      window.moreResults = moreResults;
      this.setState({
        result: data,
        newFilterFlag : false
      });
    }else{
      authentication(this);
      this.setState({
        newFilterFlag:true
      });
    }
  }

  /**
   * Callback for Order Sections to set URL for order service
   * @param {string} orderUrl 
   */
  orderCallback = (orderUrl, params=null) => {
      if(params!==null){
        let paramString = '';
        if(params['keyword']!==undefined){
          paramString=paramString+'searchterm='+params['keyword'][0]+'&keyword='+params['keyword'][1];
        }
        if(params['daterange']!==undefined){
          (paramString.length===0)?(paramString=paramString+'from='+params['daterange'][0]+'&to='+params['daterange'][1]):(paramString=paramString+'&from='+params['daterange'][0]+'&to='+params['daterange'][1])
        }
        if(params['orderstatus']!==undefined){
          (paramString.length===0)?(paramString=paramString+'orderstatus='+params['orderstatus']):(paramString=paramString+'&orderstatus='+params['orderstatus'])
        }
        if(params['orderplacedwithin']!==undefined){
          (paramString.length===0)?(paramString=paramString+'orderplacedwithin='+params['orderplacedwithin']):(paramString=paramString+'&orderplacedwithin='+params['orderplacedwithin'])            
        }
        this.props.history.push('?'+paramString);
      }
      this.setState({
        filters:orderUrl,
        newFilterFlag:true,
        result:[]
      });
  }

  /**
   * Function to change parameters as string to object
   * @param {string} string 
   */
  queryfie(string){
    return string
        .slice(1)
        .split('&')
        .map(q => q.split('='))
        .reduce((a, c) => { a[c[0]] = c[1]; return a; }, {});
  }

  orderFilterData(){
    var order = JSON.parse('{}');
    order.type = this.props.match.params.type;
    order.filters = this.queryfie(this.props.location.search);
    return order;
  }
   
  handleShipmentClick=(event)=>{
    let el = event.target;
    let jQuery = window.jQuery;
    event.preventDefault();
   sessionStorage.clear();
   window.location.href='/#/login'
  }
  render() {
    let name=sessionStorage.getItem('Name')
    if( this.state==null){
      return <Redirect to="/login" />
    }
    const { authStatus } = this.state;
    // console.log(authStatus);
    var errorMsg = '';
    // console.log("authStatus value : "+authStatus);
    if(!authStatus && authStatus!==undefined){
      errorMsg = 'Please Enter Valid Credentials.';
      // console.log(errorMsg);
    }
    
     if(authStatus){
      if(this.state.filters!=='nein' && this.state.newFilterFlag){
        getOrderResult(this, this.state.filters, this.state.authToken);
      }
      document.querySelector('body').style.backgroundColor='';
      
      //console.log(this.state.result);
      return (
        <>
        <div className="row">
          <div className="col-md-12">
              
          <div className="signout">
          <h1>{translationUtils.getTranslation(1836,'Order Status')}</h1>
		  {/* <ul className="right welcome-greeting">
		<li className="welcome-li right menu_list" title="Welcome">
							
							<a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
					
              {name}			<span className="arrowOpenClose"></span>
							</a>
							<ul className="dropdown-menu welcome-menu" role="menu">
							<span className="arrowUp"></span>
							
														<li className="" data-value="SG" tabIndex="5" id="">
								<a href="#" title="Sign Out"  onClick={(e)=>this.handleShipmentClick(e)}>Sign Out</a>
							</li>
							</ul>
						</li>
					</ul> */}

					</div>
        </div>
        </div> 
        <div className="row">
          <div className="col-md-2 col-lg-3 col-xl-2">
            <Orders callbackFromParent={this.orderCallback} intialOrderType={this.state.intialOrderType} langCode={this.state.langCode}/>
            
            <OrderSearch callbackFromParent={this.orderCallback} orderData={this.orderFilterData()}/>
  
            <GenerateReport/>
            
          </div>
          <div className="col-md-10 col-lg-9 col-xl-10">
            {
              (this.state.result.length>0)?(
                (typeof this.state.result !== 'string')?(<Result callbackFromParent={this.resultCallBack} pageLength={this.state.pageLength} pageNumber={this.state.pageNumber} data={this.state.result} key={this.state.result.OrderNo}/>):(<><p><b>{this.state.result}</b></p></>)
              ):(<><div id="preloader">
              <div id="status">&nbsp;</div>
          </div><div>...</div></>)
            }
          </div>
        </div>
        </>
      );
    }else{
      return <div></div>
    }
  }

}

export default MainWrapper;
